import { render, staticRenderFns } from "./AmThucFormCreate.vue?vue&type=template&id=9cf30d56"
import script from "./AmThucFormCreate.vue?vue&type=script&lang=js"
export * from "./AmThucFormCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports